import script from "./app-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./app-list.vue?vue&type=script&lang=ts&setup=true"

import "./app-list.vue?vue&type=style&index=0&id=9191b03a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9191b03a"]])

export default __exports__